
import React from 'react';
interface DividerProps {
  color?: string;
  direction?: "horizontal" | "vertical";
  thickness?: string;
  length?: string;
}

const Divider: React.FC<DividerProps> = ({
  color = "gray-300",
  direction = "horizontal",
  length,
}) => {
  const isVertical = direction === "vertical";
  const defaultLength = isVertical ? "h-12" : "w-full";

  return (
    <div
      className={`mt-1 ${isVertical ? "w-[2px]" : "h-[1px]"} ${length || defaultLength} bg-gradient-to-${isVertical ? "b" : "r"} from-transparent via-${color} to-transparent`}
      style={{
        backgroundImage: isVertical
          ? `linear-gradient(to bottom, transparent, ${color}, transparent)`
          : `linear-gradient(to right, transparent, ${color}, transparent)`,
      }}
    ></div>
  );
};

export default Divider;
